import { render, staticRenderFns } from "./PopOverMenu.vue?vue&type=template&id=1b9ea70a&scoped=true"
import script from "./PopOverMenu.vue?vue&type=script&lang=js"
export * from "./PopOverMenu.vue?vue&type=script&lang=js"
import style0 from "./PopOverMenu.vue?vue&type=style&index=0&id=1b9ea70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9ea70a",
  null
  
)

export default component.exports